<template>
  <div class="loan-application-loading">
    <Container>
      <Card padding="large" class="text-center">
        <Alert type="error" v-if="hasLoanApplicationError">
          <p>
            <span v-html="errorMessage" />
            <router-link
              :to="ROUTES.LOAN_APPLICATION.path"
              :title="$t('ROUTER.LOAN_APPLICATION')"
            >
              {{ $t('LOAN_APPLICATION') }}
            </router-link>
          </p>
        </Alert>
        <Margins v-else>
          <h1 class="h3 text-normal">
            {{ $t('PLEASE_WAIT_FOR_CHECK_TO_COMPLETE') }}
          </h1>
          <p class="text-small">{{ $t('IT_TAKES_SOME_TIME') }}</p>
          <Loader class="margins__double" />
        </Margins>
      </Card>
    </Container>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { POLL_PAYMENT_RESPONSE, HAS_LOAN_APPLICATION_ERROR } from '@/types';
import { Alert, Card, Container, Loader, Margins } from '@/components';
import { constants } from '@/mixins';
import { SUPPORT_EMAIL } from '@/constants';

export default {
  name: 'LoanPaymentLoading',
  mixins: [constants],
  components: {
    Container,
    Card,
    Margins,
    Loader,
    Alert,
  },
  mounted() {
    this.POLL_PAYMENT_RESPONSE();
  },
  beforeDestroy() {
    if (this.hasLoanApplicationError) {
      this.HAS_LOAN_APPLICATION_ERROR(false);
    }
  },
  methods: {
    ...mapActions([POLL_PAYMENT_RESPONSE]),
    ...mapMutations([HAS_LOAN_APPLICATION_ERROR]),
  },
  computed: {
    ...mapState(['hasLoanApplicationError']),
    errorMessage() {
      return this.$t('FORM.ERROR', [
        '<br />',
        `<a href="mailto:${SUPPORT_EMAIL}">${SUPPORT_EMAIL}</a>`,
      ]);
    },
  },
};
</script>
